module.exports = __webpack_public_path__ + "mainassets/img/faq-5.d30b6dbb.svg";